import { render, staticRenderFns } from "./CurrentFocus.vue?vue&type=template&id=3b72eb40&"
import script from "./CurrentFocus.vue?vue&type=script&lang=js&"
export * from "./CurrentFocus.vue?vue&type=script&lang=js&"
import style0 from "./CurrentFocus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CurrentFocus.vue"
export default component.exports